var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.138184,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#B9C1D9",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7763 11.7171C21.6902 9.36173 19.7779 8.43525 17.3202 8.03232L17.5031 4.78727L15.5893 4.64842L15.4114 7.808C14.9082 7.77138 14.3934 7.74428 13.8818 7.71764L14.0614 4.53712L12.1488 4.39806L11.9652 7.64217C11.5505 7.62081 11.1431 7.59926 10.7463 7.57061L10.7467 7.56045L8.10725 7.36755L7.98883 9.47726C7.98883 9.47726 9.40362 9.55227 9.37864 9.57728C10.1537 9.63383 10.3799 10.1168 10.4308 10.5229L10.2225 14.2197C10.276 14.2239 10.3456 14.2312 10.4241 14.2483C10.3602 14.2437 10.2922 14.2384 10.2219 14.234L9.9294 19.4128C9.88131 19.6621 9.71529 20.0533 9.1736 20.0148C9.19692 20.039 7.78253 19.9134 7.78253 19.9134L7.26921 22.2448L9.75976 22.4257C10.2232 22.4601 10.6788 22.5014 11.1264 22.5367L10.9422 25.8188L12.8539 25.958L13.0368 22.7106C13.5612 22.76 14.0688 22.8013 14.5648 22.8369L14.3818 26.0692L16.2957 26.208L16.4808 22.9318C19.7091 22.9752 22.0081 22.3024 22.4634 19.2041C22.8307 16.7095 21.7495 15.5059 19.9487 14.9204C21.0912 14.4179 21.8422 13.4407 21.7763 11.7171ZM18.7032 18.5402C18.566 20.9929 14.5129 20.4182 13.2158 20.3252L13.4614 15.9766C14.7587 16.0714 18.8475 15.9819 18.7032 18.5402ZM18.1589 12.3403C18.0326 14.5716 14.6539 14.0646 13.5736 13.9861L13.796 10.0423C14.8764 10.1208 18.2898 10.013 18.1589 12.3403Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcIcon);
export default __webpack_public_path__ + "static/media/btc-icon.62fed41224c39f8705a39614127565d3.svg";
export { ForwardRef as ReactComponent };